import React from "react";

const CollectionBox = ({ collections, onSelect, searchQuery, activeIndex, setActiveIndex }) => {
  const filteredCollections = collections.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      {filteredCollections.length > 0 ? (
        filteredCollections.map((item, index) => (
          <div
            className={`collection-box ${activeIndex === index ? "active" : ""}`}
            key={index}
            onClick={() => {
              onSelect(item.title, index);
              setActiveIndex(index);
            }}
          >
            <div className="icon-wrap">{item.icon}</div>
            <div className="info-wrap">
              <h4>{item.title}</h4>
              <span>{item.papers} papers</span>
            </div>
          </div>
        ))
      ) : (
        <p className="no-collections-found">No collections found</p>
      )}
    </>
  );
};

export default CollectionBox;